import { render, staticRenderFns } from "./tableHeder.vue?vue&type=template&id=79e36154&"
import script from "./tableHeder.vue?vue&type=script&lang=js&"
export * from "./tableHeder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports